import { ArrowLeft, Mail, Clock } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ContactPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-6 py-16">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="h-4 w-4" />
          Back
        </button>

        <h1 className="font-heading text-3xl font-semibold text-foreground mb-8">
          Contact Us
        </h1>

        <div className="space-y-6 text-muted-foreground">
          <p>
            Have questions or need help? We're here for you.
          </p>

          <div className="space-y-4">
            <div className="flex items-start gap-3 p-4 bg-secondary/30 rounded-lg">
              <Mail className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <h3 className="text-foreground font-medium mb-1">Email</h3>
                <a 
                  href="mailto:decisora.help@gmail.com" 
                  className="text-primary hover:underline text-sm"
                >
                  decisora.help@gmail.com
                </a>
              </div>
            </div>

            <div className="flex items-start gap-3 p-4 bg-secondary/30 rounded-lg">
              <Clock className="h-5 w-5 text-primary mt-0.5" />
              <div>
                <h3 className="text-foreground font-medium mb-1">Response Time</h3>
                <p className="text-sm">
                  We typically respond within 24–48 hours.
                </p>
              </div>
            </div>
          </div>

          <div className="pt-4">
            <p className="text-sm">
              For urgent payment issues, please include "URGENT" in your email subject line.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
